module.exports = __webpack_public_path__ + "img/assembler-1.183aa152.png";